import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../components/Header';
import FAQs from '../components/FAQs';
import Footer from '../components/Footer';
import BackButton from '../components/BackButton';
import SEO from '../components/SEO';

const faqKeys = [
  'whatAreBinauralBeats',
  'howDoesTrialWork',
  'needHeadphones',
  'howLongToListen',
  'whenWillISeeResults',
  'canICancelAnytime',
  'areBinauralBeatsSafe',
  'doTheyWorkForEveryone',
];

const FAQPage: React.FC = () => {
  const { t } = useTranslation('common');
  const { t: tFaqs } = useTranslation('faqs');

  const faqItems = faqKeys.map((key) => ({
    question: tFaqs(`items.${key}.question`),
    answer: tFaqs(`items.${key}.answer`),
  }));

  return (
    <div className='min-h-screen' style={{ background: 'rgb(8 6 20 / 100%)' }}>
      <SEO
        title={t('seo.faqs.title')}
        description={t('seo.faqs.description')}
        canonical='/faqs'
        faqItems={faqItems}
      />
      <Header showUserInfo={true} variant='player' />

      <div className='page'>
        <div className='container-mobile'>
          <BackButton />
          <div className='subtitle'>
            <div className='flex items-center justify-center mb-4 md:mb-6'>
              <h1
                className='text-2xl sm:text-3xl md:text-4xl font-bold'
                style={{
                  color: 'var(--text-primary)',
                  fontFamily: 'Lexend Deca, sans-serif',
                }}
              >
                Preguntas Frecuentes
              </h1>
            </div>
            <p
              style={{
                color: 'var(--text-secondary)',
                maxWidth: '700px',
                fontSize: '0.9rem',
              }}
            >
              Encuentra respuestas a las preguntas más comunes sobre los sonidos
              binaurales, nuestra app, y cómo aprovechar al máximo tu
              experiencia de meditación.
            </p>
          </div>

          <FAQs showTitle={false} />

          <div className='contact-section'>
            <h3
              style={{
                color: 'var(--text-primary)',
                fontSize: '1.3rem',
                marginBottom: '1rem',
                fontFamily: 'Lexend Deca, sans-serif',
              }}
            >
              ¿No encontraste lo que buscabas?
            </h3>
            <p
              style={{
                color: 'var(--text-secondary)',
                marginBottom: '1.5rem',
              }}
            >
              Nuestro equipo está aquí para ayudarte. Contáctanos y te
              responderemos lo antes posible.
            </p>
            <a
              href='mailto:contact@presencia-app.com'
              className='btn btn-primary'
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
              }}
            >
              <svg
                width='20'
                height='20'
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
              >
                <path d='M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z'></path>
                <polyline points='22,6 12,13 2,6'></polyline>
              </svg>
              Contactar Soporte
            </a>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default FAQPage;
